import { useNavigate, useSearchParams } from "react-router-dom";
import { Information } from "./information";
import { Experience } from "./experience";
import { Academics } from "./academics";
// import { Evaluations } from "./evaluations";
import { Documents } from "./documents";
import { textChooser } from "../../../common/util/textChooser";
import { PhotoUpload } from "./photoUpload";
import "./index.scss";
import { useUser } from "../../../common/hooks/User";
import { Button } from "../../../common/components/controls/button";
import { useValidateProfile } from "../../../common/hooks/useValidProfile";
import { InfoText } from "../../../common/components/info_text";

interface IProfileEdit {
  handleSubmit?: () => void;
  isLoadingSubmit?: boolean;
}

export const ProfileEdit = ({ handleSubmit, isLoadingSubmit = false }: IProfileEdit) => {
  const [params] = useSearchParams();
  const search = params.get('ref')
  const navigate = useNavigate();

  const { getDataAll } = useUser()
  const { email } = getDataAll()

  const { data, isLoading } = useValidateProfile(email)

  return (
    <div className="page -profile-edit">
      <h1 className="heading colorNavy sizeLg">
        {textChooser("txt125")}
      </h1>

      <section className="profile-edit-section">
        <div className="profile-edit-col">
          <Information />
          <Experience />
          <Academics />
          {/* <Evaluations /> */}
          <Documents />

          <Button primary hidden={!search || isLoading} disabled={!data} onClick={() => navigate(search ?? '')}>{textChooser('txt185')}</Button>
          <Button primary hidden={!handleSubmit || isLoading} disabled={!data || isLoadingSubmit} onClick={handleSubmit}>{textChooser('txt187')}</Button>

          {!data && <InfoText text={textChooser("txt183")} type="danger" />}
        </div>
        <div className="profile-edit-col">
          <PhotoUpload />
        </div>
      </section>
    </div>
  )
}
